import React, { Component } from "react";
import asu from 'app/assets/screen7Logos/Helios_DCEE.png'
import backgroundImg from 'app/assets/screen7Logos/scre-7-bg.png'
import './screen7Logo.css'

class Screen7Logo extends Component {
    render() {
        return(
            <div container className="screen-content-grid">
                <img key={1} className='backgroundImg' alt="background" src={backgroundImg} />
                <img key={2} className='heliosImg' alt="logo" src={asu} />
            </div>
        );
    }
}

export default Screen7Logo;
